import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const navLinks = [
    { path: '/', label: 'Inicio' },
    { path: '/empresa', label: 'Empresa' },
    { path: '/servicios', label: 'Servicios' },
    { path: '/instalaciones', label: 'Instalaciones' },
    { path: '/beneficios', label: 'Beneficios' },
    { path: '/ayudas-subvenciones', label: 'Ayudas' },
    { path: '/ciudades', label: 'Ciudades' },
    { path: '/blog', label: 'Blog' },
    { path: '/calculadora-solar', label: 'Calculadora Solar' },
    { path: '/faq', label: 'FAQ' },
    { path: '/contacto', label: 'Contacto' }
  ];

  return (
    <header className="sticky top-0 z-50 w-full border-b border-nubia-gray-light bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60">
      <div className="container mx-auto px-4">
        <div className="flex h-20 items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center hover:opacity-90 transition-opacity">
            <img 
              src="/nubia-solar-logo.png" 
              alt="Nubia Solar" 
              className="h-12 md:h-16 lg:h-20 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 text-sm font-medium transition-colors rounded-md ${
                  isActive(link.path) 
                    ? 'text-nubia-green-primary bg-nubia-gold-soft/10' 
                    : 'text-nubia-text-dark hover:text-nubia-green-primary hover:bg-nubia-gray-light'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-3">
            <Button 
              variant="outline" 
              size="sm"
              className="border-nubia-green-primary text-nubia-green-primary hover:bg-nubia-green-primary hover:text-white"
              onClick={() => window.location.href = 'tel:+34604921745'}
            >
              <Phone className="w-4 h-4 mr-2" />
              Llamar
            </Button>
            <Link to="/contacto">
              <Button 
                size="sm"
                className="bg-nubia-gold-primary hover:bg-nubia-gold-primary/90 text-nubia-green-primary font-semibold shadow-md hover:shadow-lg transition-all"
              >
                Solicitar Presupuesto
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-nubia-text-dark hover:text-nubia-green-primary transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-nubia-gray-light animate-in slide-in-from-top-2">
            <nav className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-3 text-sm font-medium transition-colors rounded-md ${
                    isActive(link.path) 
                      ? 'text-nubia-green-primary bg-nubia-gold-soft/10' 
                      : 'text-nubia-text-dark hover:bg-nubia-gray-light'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
              <div className="flex flex-col gap-2 pt-4 border-t border-nubia-gray-light mt-2">
                <Button 
                  variant="outline" 
                  size="sm"
                  className="w-full border-nubia-green-primary text-nubia-green-primary hover:bg-nubia-green-primary hover:text-white"
                  onClick={() => {
                    window.location.href = 'tel:+34604921745';
                    setMobileMenuOpen(false);
                  }}
                >
                  <Phone className="w-4 h-4 mr-2" />
                  Llamar
                </Button>
                <Link to="/contacto" onClick={() => setMobileMenuOpen(false)}>
                  <Button 
                    size="sm"
                    className="w-full bg-nubia-gold-primary hover:bg-nubia-gold-primary/90 text-nubia-green-primary font-semibold"
                  >
                    Solicitar Presupuesto
                  </Button>
                </Link>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;